//Install
import React, { Component } from "react";

//Element
class Corporation extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB rj401n" },
            //Element
            React.createElement("li", { className: "S6pt64 C96Q4r" },
                //Element
                React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/az/haqqimizda" },
                    //Element
                    "Haqqımızda"
                )
            ),
            //Element
            React.createElement("li", { className: "S6pt64 C96Q4r" },
                //Element
                React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/az/tarixce" },
                    //Element
                    "Tarixçə"
                )
            ),
            //Element
            React.createElement("li", { className: "S6pt64 C96Q4r" },
                //Element
                React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/az/filiallar" },
                    //Element
                    "Filiallar"
                )
            ),
            //Element
            React.createElement("li", { className: "S6pt64 C96Q4r" },
                //Element
                React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/az/səlahiyyət-sənədləri" },
                    //Element
                    "Səlahiyyət Sənədləri"
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Corporation;